import styled, { css } from 'styled-components';

export const BreadcrumbWrapper = styled.div`
  [class*='Breadcrumbsstyle__BreadcrumbsWrapper-sc'] {
    background-color: var(--gallery);
  }

  [class*='Breadcrumbsstyle__BreadcrumbsItem-sc'] {
    a {
      text-decoration: none !important;
    }

    [class*='Tooltipstyle__TooltipWrapper-sc'] {
      z-index: 101;
      position: absolute;
    }
  }
  svg {
    ${props =>
      props.direction === 'rtl' &&
      css`
        rotate: 180deg;
      `}
  }
`;
